import { DEFAULT_CACHE_KEY, generateCacheTTL } from '../../utils/functions/cache';
import {
  GET_RECEIPTS_API_REQUEST,
  GET_RECEIPTS_API_SUCCESS,
  GET_RECEIPTS_API_ERROR,
  GET_NEXT_RECEIPTS_SUCCESS,
  GET_INDIVIDUAL_RECEIPT_API_REQUEST,
  GET_INDIVIDUAL_RECEIPT_API_SUCCESS,
  GET_INDIVIDUAL_RECEIPT_API_ERROR,
  GET_INDIVIDUAL_RECEIPT_CANCEL,
  UPDATE_RECEIPTS_CURRENT_CACHE_KEY,
} from '../../constants/receiptActionNames';
import { SELECT_CLIENTS_SUCCESS } from '../../constants/authActionNames';

import {
  stringToDate,
  isoStringToDate,
  uuidv4,
  dateToString,
  dateTimeToString,
  getAllKeys,
  uniq,
  getKeys,
  addArrayOnce,
} from '../../utils/functions';
import { customPaymentType, premiumPaymentType, statusOk } from '../../utils/variables';
import { CLEAR_RECEIPTS_CACHE } from '../../constants/miscActionNames';

const createReceipt = payloadArray => {
  if (!Array.isArray(payloadArray)) return null;
  return payloadArray.map((object, index) => {
    // console.log("Create Receipt", object);
    return {
      id: index,
      receiptNo: object?.receiptNo,
      policies: object?.policies,
      totalReceiptAmount: object?.totalReceiptAmount,
    };
  });
};

let searchKeys = [];

const createPayload = (payloadArray, body, cacheKey) => {
  // console.log("PAyload Array", payloadArray);
  if (!Array.isArray(payloadArray)) return null;
  searchKeys = [];

  const newReceipt = payloadArray.map((object, index) => {
    const position = index;

    object?.receipts?.forEach(x => {
      const arrayPolicies = Array.isArray(x?.policies) ? x?.policies : [x?.policies];
      x.policies = arrayPolicies;
    });

    const receipt = {
      ...object,
      index: position,
      cacheId: `${object?.orderNo}_${cacheKey}`,
      cacheKey,
      id: object?.orderNo,
      slug: object?.orderNo,
      date: dateToString(isoStringToDate(object?.paymentDate)),
      filterDate: dateToString(isoStringToDate(object?.paymentDate)),
      filterCurrency: object?.currency,
      totalAmount: object?.totalOrderAmount,
      currency: object?.currency,
      orderNo: object?.orderNo,
      body,

      // receiptNo: object?.receiptNo,
    };
    // console.log("receipt", receipt);
    return receipt;
  });
  /*
  newReceipt.sort((a, b) => {
    return b.filterDate < a.filterDate ? -1 : 1;
  });
  */

  return newReceipt;
};

export const initialState = {
  isPending: false,
  isError: false,
  isSuccess: false,
  response: null,
  error: null,
  isIndividualReceiptPending: false,
  isIndividualReceiptSuccess: false,
  isIndividualReceiptError: false,
  individualReceiptResponse: null,
  allRows: [],
  count: 0,
  nextItemCount: 0,
  nextScrollCount: 0,
  nextStartIndex: 0,
  searchKeys,
  [DEFAULT_CACHE_KEY]: null,
  currentCacheKey: '',
  total: 0,
  filters: [],
  // pageItemCount: 5,
};
// createPayload(payloadData, 0)

function receiptsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_RECEIPTS_API_REQUEST:
      return {
        ...state,
        isPending: true,
        isError: false,
        isSuccess: false,
      };
    case GET_RECEIPTS_API_SUCCESS: {
      const response = action?.payload;
      const rowInfo = response?.payload;
      const cacheKey = action?.cacheKey;
      const body = action?.body;

      const initialRows = rowInfo?.receipts;
      // console.log("Response", initialRows);
      const newFilters = initialRows?.[0]?.result?.paymentTypes || [];
      const newTotal = initialRows?.[0]?.result?.total || 0;
      const newData = initialRows?.[0]?.result?.data || [];

      const newRows = createPayload(newData, body, cacheKey) || [];

      // const allRows = [...newRows, ...state?.allRows];
      const isError = response?.responseType !== statusOk;
      const nextStartIndex = body?.nextStartIndex;
      const nextScrollCount = body?.nextScrollCount;
      const nextItemCount = body?.nextItemCount;

      const count = typeof state?.count === 'object' ? { ...state?.count } : {};
      count[cacheKey] = newTotal;

      return {
        ...state,
        isPending: false,
        isError,
        isSuccess: true,
        response,
        filters: newFilters,
        total: newTotal,
        // rows,
        count,
        searchKeys,
        allRows: newRows,
        currentCacheKey: cacheKey,
        [DEFAULT_CACHE_KEY]: {
          ...(state[DEFAULT_CACHE_KEY] || {}),
          [cacheKey]: {
            time: generateCacheTTL(),
            payload: response,
          },
        },
        nextItemCount,
        nextScrollCount,
        nextStartIndex,
      };
    }

    case GET_RECEIPTS_API_ERROR:
      return {
        ...state,
        isPending: false,
        isError: true,
        isSuccess: false,
        error: action?.payload,
      };

    case UPDATE_RECEIPTS_CURRENT_CACHE_KEY:
      return {
        ...state,
        currentCacheKey: action?.payload,
      };

    case GET_NEXT_RECEIPTS_SUCCESS: {
      const nextStartIndex = action?.payload?.nextStartIndex;
      const nextScrollCount = action?.payload?.nextScrollCount;
      const nextItemCount = action?.payload?.nextItemCount;

      return {
        ...state,

        nextItemCount,
        nextScrollCount,
        nextStartIndex,
      };
    }

    case GET_INDIVIDUAL_RECEIPT_API_REQUEST: {
      return {
        ...state,
        isIndividualReceiptPending: true,
        isIndividualReceiptSuccess: false,
        isIndividualReceiptError: false,
      };
    }
    case GET_INDIVIDUAL_RECEIPT_API_SUCCESS: {
      const response = action?.payload;
      /// console.log('Reducer', response);
      return {
        ...state,
        isIndividualReceiptPending: false,
        isIndividualReceiptSuccess: true,
        isIndividualReceiptError: false,
        individualReceiptResponse: response,
      };
    }
    case GET_INDIVIDUAL_RECEIPT_API_ERROR: {
      return {
        ...state,
        isIndividualReceiptPending: false,
        isIndividualReceiptSuccess: false,
        isIndividualReceiptError: true,
      };
    }
    case GET_INDIVIDUAL_RECEIPT_CANCEL: {
      return {
        ...state,
        isIndividualReceiptPending: false,
        isIndividualReceiptSuccess: false,
        isIndividualReceiptError: false,
      };
    }

    case SELECT_CLIENTS_SUCCESS: {
      return {
        ...state,
        allRows: initialState.allRows,
        [DEFAULT_CACHE_KEY]: null,
      };
    }

    case CLEAR_RECEIPTS_CACHE: {
      return {
        ...state,
        count: initialState.count,
        allRows: initialState.allRows,
        [DEFAULT_CACHE_KEY]: null,
      };
    }

    default:
      return state;
  }
}

export default receiptsReducer;
